export default {
  agenda: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/schedule/resources/props.js